import { useTranslations } from '@vocab/react';
import type { TranslationKeys } from '@vocab/core';
import translations from './.vocab';

type SourceOptionsTranslationKeys = TranslationKeys<typeof translations>;

const labelToKeyMap: Record<string, SourceOptionsTranslationKeys> = {
  'Internal Candidate': 'Internal Candidate',
  'Job Board': 'Job Board',
  'Previous Candidate': 'Previous Candidate',
  'Professional Network': 'Professional Network',
  Recruiter: 'Recruiter',
  Referral: 'Referral',
  Other: 'Other',
};

export const useSourceOptions = () => {
  const { t } = useTranslations(translations);

  return {
    getSourceOption: (option: string) => {
      const translationKey = labelToKeyMap[option];
      return t(translationKey);
    },
  };
};

export default useSourceOptions;
